import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  IntegrationApiClientDto,
  IntegrationApiClientReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import IntegrationApiClientInline, {
  IntegrationApiClientInlineProps,
} from "./IntegrationApiClientInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: IntegrationApiClientDto | IntegrationApiClientReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<IntegrationApiClientInlineProps>;
}

export default function IntegrationApiClientLink({
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.IntegrationApiClientRead]}
      to={ROUTE_PATH.MANAGEMENT_INTEGRATION_API_CLIENT_VIEW(entity?.id || entityId || "")}
      content={<IntegrationApiClientInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
